/*
 * trpc (context)
 */
import { createContext } from "react"

/* Context */
const TrpcContext = createContext<any>(null)
TrpcContext.displayName = "Trpc-Context"

export { TrpcContext }
